import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MyTable, { MyTableBody, MyTableCol, MyTableHeader, MyTableRow } from 'components/MyTable';
import PermissionHide from 'components/PermissionHide';
import Spin from 'components/Spin';
import React from 'react';
import { FormattedNumber } from 'react-intl';
import { useObservable } from 'react-use-observable';
import ordersService from 'v2/services/orders';

import type { IInvoiceItem } from 'v2/components/Pages/Orders/interfaces';

const indexes = [
  { title: 'Conteúdo', ordering: false },
  { title: 'Qtd,', ordering: false },
  { title: 'Un.', ordering: false },
  { title: 'Total', ordering: false },
];

const InvoiceItems = () => {
  useObservable(() => ordersService.loadInvoiceItems(), []);
  const [isLoading] = useObservable(() => ordersService.isLoadingInvoiceItems(), []);
  const [invoiceItems] = useObservable(() => {
    return ordersService.getInvoiceItems();
  }, []);

  return (
    <ExpansionPanel>
      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls='invoice-content' id='invoice-header'>
        <Typography>Itens do pedido</Typography>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>
        {isLoading ? (
          <div style={{ width: '100%', textAlign: 'center' }}>
            <Spin />
          </div>
        ) : (
          <MyTable>
            <MyTableHeader index={indexes} />
            <MyTableBody>
              {Array.isArray(invoiceItems) && invoiceItems.length
                ? invoiceItems.map((item: IInvoiceItem) => (
                    <MyTableRow key={`item-${item.id}`}>
                      <MyTableCol>
                        {item.id} - {item.description}
                      </MyTableCol>
                      <MyTableCol>{item.units}</MyTableCol>
                      <MyTableCol>
                        <PermissionHide inverse={1} action='myeduzz:minhas-entregas:ocultar-valores'>
                          <FormattedNumber format='BRL' value={item.unitary_value} />
                        </PermissionHide>
                        <PermissionHide inverse={false} action='myeduzz:minhas-entregas:ocultar-valores'>
                          <em>oculto</em>
                        </PermissionHide>
                      </MyTableCol>
                      <MyTableCol>
                        <PermissionHide inverse={1} action='myeduzz:minhas-entregas:ocultar-valores'>
                          <FormattedNumber format='BRL' value={item.amount} />
                        </PermissionHide>
                        <PermissionHide inverse={false} action='myeduzz:minhas-entregas:ocultar-valores'>
                          <em>oculto</em>
                        </PermissionHide>
                      </MyTableCol>
                    </MyTableRow>
                  ))
                : 'Nenhum item encontrado...'}
            </MyTableBody>
          </MyTable>
        )}
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
};
export default InvoiceItems;
